import { GridFilterInputValue, GridFilterOperator } from "@mui/x-data-grid-premium";

const notEqualsOperator: GridFilterOperator<any, string> = {
	label: "Not equal",
	value: "notEquals",
	getApplyFilterFn: (filterItem) => {
		// if the filter isn’t fully defined, don’t apply anything
		if (!filterItem.field || !filterItem.value || !filterItem.operator) {
			return null;
		}
		return (cellValue) => {
			// only truthy when the cellValue is different from filterItem.value
			return cellValue != null && cellValue.toLocaleLowerCase() !== filterItem.value.toLocaleLowerCase();
		};
	},
	// reuse the default text‐input for entering the filter value
	InputComponent: GridFilterInputValue,
};

export { notEqualsOperator };
